import client from 'api/client'

export const fetchTranscript = ({collectionId, locale}) =>
  client().get(`/collections/v2/${collectionId}/transcript`, {locale})

export const updateTranscript = ({collectionId, data, locale, checkout = true}) => client().patch(
  `/collections/v2/${collectionId}/transcript`,
  {...data, locale, checkout}
)
